module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av131-83080347b8ee51e9b1bb86bac7f1062a.jpg";